// extracted by mini-css-extract-plugin
module.exports = {"message":"ModalError-message-JD3tq ErrorBoundaryError-message-1UMJK","details":"ModalError-details-1DD-5 ErrorBoundaryError-details-1-jzU"};